var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 73,
    viewBox: "0 0 97 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 0.142822,
    y: 0.902893,
    width: 96.5938,
    height: 71.6664,
    rx: 10,
    fill: "#110B3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.418 56.339V17.1493C34.418 16.3855 35.2397 15.9036 35.9062 16.2766L71.2726 36.0636C71.9582 36.4471 71.9541 37.4351 71.2653 37.813L35.899 57.2158C35.2325 57.5814 34.418 57.0992 34.418 56.339Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpPlay);
export default __webpack_public_path__ + "static/media/help-play.1592bc57ffe508e559684e6439bb3a89.svg";
export { ForwardRef as ReactComponent };